import { useEffect } from 'react';
import { media, pageMetadata, company } from '../data/site';
import type { PageKey } from '../data/site';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useDocumentMeta(page: PageKey = 'home') {
  useEffect(() => {
    const metadata = pageMetadata[page];
    document.title = metadata.title;
    setMeta('name', 'description', metadata.description);
    setMeta('name', 'theme-color', '#1b2308');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', company.name);
    setMeta('property', 'og:title', metadata.title);
    setMeta('property', 'og:description', metadata.description);
    setMeta('property', 'og:image', media.socialPreview);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');
    setMeta('property', 'og:image:alt', 'D.A. Alexander & Company — Outdoor spaces, thoughtfully designed. Illustrative garden landscape.');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', metadata.title);
    setMeta('name', 'twitter:description', metadata.description);
    setMeta('name', 'twitter:image', media.socialPreview);

    const href = media.favicon;
    document.head.querySelectorAll('link[rel~="icon"]').forEach((l) => l.remove());
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/png';
    icon.sizes = '64x64';
    icon.href = href;
    document.head.appendChild(icon);
  }, [page]);
}

